/**
 * The Studio, at alg.<env>.tricorder.icu: the protocol library, the authoring
 * canvas and the run screens. The program around them (router, sign-in,
 * /config, language, toasts) is the platform's AppShell.
 */
import { AppShell } from '@ai4nr/tricorder-ui'

import Home from './pages/Home'
import { routes } from './routes'

export default function App() {
  return <AppShell home={<Home />} routes={routes} />
}
